export default __webpack_public_path__ + "static/media/centimeter.6d5bf97c.svg";